<template>
  <v-dialog transition="dialog-top-transition" max-width="90%" persistent v-model="dialog_log">
    <template v-slot:default="">
      <v-card>
        <div class="dialog-header">
          <div class="dialog-header__icon-wrap">
            <v-icon color="#0052A0">mdi-clipboard-text-clock-outline</v-icon>
          </div>
          <div>
            <div class="dialog-header__title">Log do Protocolo</div>
            <div class="dialog-header__sub">{{ protocolo }}</div>
          </div>
          <v-spacer></v-spacer>
          <v-btn icon @click="$emit('close')"><v-icon color="#64748b">mdi-close</v-icon></v-btn>
        </div>

        <v-card-text class="pa-6">
          <v-data-table
            :headers="headers_log"
            :items="registros"
            item-key="protocolo"
            :items-per-page="5"
            class="log-table elevation-0"
            :footer-props="{
              'items-per-page-text': 'Registros por página: ',
              'page-text': '{0}-{1} de {2}',
              'items-per-page-all-text': 'Listar todos',
            }"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ converterDataTime(item.data) }}</td>
                <td class="text-center">{{ item.name }}</td>
                <td class="text-center">{{ item.user_ip }}</td>
                <td class="text-center">{{ item.transacao }}</td>
                <td class="text-center">{{ item.acao }}</td>
                <td class="text-center">{{ item.motivo }}</td>
                <td class="text-center">{{ item.observacao }}</td>
                <td class="text-center">{{ item.status }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions style="border-top:1px solid #f1f5f9;padding:12px 20px;">
          <v-spacer></v-spacer>
          <v-btn text rounded color="grey darken-1" @click="$emit('close')">
            <v-icon left small>mdi-close</v-icon>Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import helper from "../mixins/helper";

export default {
  name: "LogComponent",
  mixins: [helper],
  props: {
    registros: { default: [] },
    protocolo: { default: '' },
    dialog_log: { default: false },
  },
  data: () => ({
    headers_log: [
      { text: 'Data/Hora', value: 'data', align: 'start' },
      { text: 'Usuário', value: 'name', align: 'center' },
      { text: 'IP', value: 'user_ip', align: 'center' },
      { text: 'Transação', value: 'transacao', align: 'center' },
      { text: 'Ação', value: 'acao', align: 'center' },
      { text: 'Motivo', value: 'motivo', align: 'center' },
      { text: 'Observação', value: 'observacao', width: '15%', align: 'center' },
      { text: 'Status', value: 'status_nome', width: '15%', align: 'center' },
    ],
  }),
  methods: {
    emitclick() {
      this.$emit("emit-dialog_log", !this.dialog_log);
    },
  },
};
</script>

<style scoped>
.dialog-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 24px;
  border-bottom: 1px solid #f1f5f9;
}
.dialog-header__icon-wrap {
  width: 36px; height: 36px;
  background: #e8f0fe;
  border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.dialog-header__title {
  font-family: 'Inter', sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
  color: #1e293b;
}
.dialog-header__sub {
  font-family: 'Inter', sans-serif;
  font-size: 0.78rem;
  color: #94a3b8;
  margin-top: 2px;
}
.log-table >>> th {
  font-family: 'Inter', sans-serif !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  color: #64748b !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: #f8fafc !important;
}
.log-table >>> td {
  font-family: 'Inter', sans-serif !important;
  font-size: 0.85rem !important;
  color: #1e293b !important;
  font-weight: 400 !important;
}
</style>
